export const SECTION_KEYS = {
  WHY: 'why',
  WHAT: 'what',
  HOW: 'how'
};

export const DEFAULT_SECTION_KEYS = [SECTION_KEYS.WHY, SECTION_KEYS.WHAT];
